import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Group } from '../../../../../core/shared/models/group.model';
import { NoWhiteSpaceValidator } from '../../../../../core/shared/validators/whitespace-validator';
import { AddMembers } from '../../../../../core/shared/actions/members.actions';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { applicationUserState } from '../../../../../core/shared/states/application.user.state';
import { ApplicationUser } from '../../../../../core/shared/models/application.user.model';
import { GetApplicationUsers } from '../../../../../core/shared/actions/application.user.actions';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
@Component({
  selector: 'app-member-modal',
  templateUrl: './member-modal.component.html',
  styleUrls: ['./member-modal.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LoadingSpinnerComponent,
    MatSnackBarModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatIcon,
    MatButton,
    MatIconButton,
  ],
})
export class MemberModalComponent implements OnInit {
  @Input() public group!: Group;
  @Input() public applicationName!: string;

  loading = true;
  entryForm!: FormGroup;
  error: string | undefined;
  userList: ApplicationUser[] = [];
  private formSubscription: Subscription = new Subscription();
  public readonly users: Observable<
    ApplicationUser[]
  >;
  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private store: Store,
    private snackBar: MatSnackBar
  ) {
    this.createForm();
    this.users = this.store.select(applicationUserState.getApplicationUsersList);
  }

  ngOnInit() {
    this.store.dispatch(new GetApplicationUsers(this.applicationName));
    this.users.subscribe((users) => {
      this.userList = users;
      if (this.userList.length > 0) {
        this.loading = false;
        this.entryForm.patchValue({ group_name: this.userList[0].email });
      }
    });
  }

  //   // Handle Create  update button click
  onCreate_Update(): void {
    this.entryForm.controls['groupName'].setValue(this.group.group_name);
    this.formSubscription.add(
      this.store
        .dispatch(new AddMembers(this.group.group_name, this.entryForm.value))
        .subscribe(
          (resp: any) => {
            this.activeModal.close();
            this.showSnackBar('Member added successfully!', false);
          },
          (error) => {
            this.activeModal.close();
            this.showSnackBar('An error occurred:' + error.error.message, true);
          }
        )
    );
  }

  public changeUser(e: any): void {
    const find = this.userList.find((x) => x?.email === e.target.value);
  }
  showSnackBar(message: string, isError: boolean): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, // Duration in milliseconds
      panelClass: isError ? 'error-snackbar' : 'success-snackbar', // Custom CSS classes for styling
    });
  }
  // reactive form
  private createForm() {
    this.entryForm = this.formBuilder.group({
      memberEmail: new FormControl('', [
        Validators.required,
        NoWhiteSpaceValidator.cannotContainSpace,
      ]),
      groupName: [''],
    });
  }
}
